export const FEATURE_FLAG_KEYS = {
  PAYMENT_FLOW_REVAMP_PHASE1: 'payment-flow-revamp-phase1',
  N_COUNT_TICKETS_ENABLED: 'n_count_tickets_enabled',
  SUBSCRIBE_TERM_MESSAGES: 'subscribe_term_messages',
  LUMP_SUM_TERM_MESSAGES: 'lump_sum_term_messages',
  TERMS_PAYBACK_MESSAGES: 'terms_payback_messages',
  IPAD_TERM_MESSAGES: 'ipad_term_messages',
  BUSINESS_TERM_MESSAGES: 'business_term_messages',
  SMART_TALK_TERM_MESSAGES: 'smart_talk_term_messages',
  SMART_TALK_TRIAL_TERM_MESSAGES: 'smart_talk_trial_term_messages',
  NAVER_PAY_TERM_MESSAGES: 'naver_pay_term_messages',
  // 튜터 지정권(tutor-connect) 결제 약관 — 일반 패키지(LUMP_SUM)와 약관 내용이 달라 별도 플래그를 사용한다.
  TUTOR_CONNECT_TERM_MESSAGES: 'tutor_connect_term_messages',
  // 일본 판매 튜터 지정권 결제 약관 — 국가별 환불·유효기간 정책을 분리한다.
  TUTOR_CONNECT_TERM_MESSAGES_JP: 'tutor_connect_term_messages_jp',
  PAYMENT_TERMS_INFORMATION: 'payment_terms_information',
  // 결제 이용약관 전문(JSON 블록). 값이 있으면 PAYMENT_TERMS_INFORMATION(노션 페이지) 대신 이 내용을 렌더링한다.
  PAYMENT_TERMS_CONTENT: 'payment_terms_content',
  // 일본 로그인 국가 사용자가 확인하는 결제 이용약관 전문(JSON 블록).
  PAYMENT_TERMS_CONTENT_JP: 'payment_terms_content_jp',
  COUPON_ERROR_MESSAGE: 'coupon_error_message',
  VALIDATE_SUBSCRIBE_ERROR_MESSAGE: 'validate_subscribe_error_message',
  PAGECALL_REPLAY_KEY: 'pagecall_replay_key',
  AI_HOME_BANNER_IMAGE: 'ai_home_banner_image',
  HOME_BANNER_API_ENABLED: 'home_banner_api_enabled',
  JP_BUSINESS_CURRICULUM_POPUP_ENABLED: 'jp_business_curriculum_popup_enabled',
  APPLE_LOGIN: 'apple_login',
  LINE_LOGIN: 'line_login',
  GOOGLE_LOGIN: 'google_login',
  SUBMITTING_RUNTIME_VERSION: 'submitting_runtime_version',
  GLOBAL_LANGTIME_CODE: 'global_langtime_code',

  TESTABLE_USER_ID_LIST: 'testable_user_id_list',
  SUBSCRIBE_TICKETS_URL_ENABLED: 'subscribe_tickets_url_enabled',
  PAYBACK_TICKETS: 'payback_tickets',
  UI_TAB_BUSINESS_ENABLED: 'ui_tab_business_enabled',
  PODOLINGO_BANNER: 'podolingo_banner',
  SIGN_IN_IMAGE_VARIANT: 'sign_in_image_variant',

  TBD_260225_SELFTEST_MIGRATION: 'tbd_260225_selftest_migration',
  TBD_260424_ADDITIONAL_TRIAL_BANNER: 'tbd_260424_additional_trial_banner',
  TBD_260429_NPS_DEFERRED_PROMPT: 'tbd_260429_nps_deferred_prompt',
  JP_UNLIMIT_WEEKLY_CHANGE_LIMIT: 'jp_unlimit_weekly_change_limit',
  POST_PURCHASE_BOOKING_ENABLED: 'post_purchase_booking_enabled',
  LEMONBOARD_PRESTUDY_ROOM_ROLLBACK: 'lemonboard_prestudy_room_rollback',
  TBD_PRESTUDY_TIME: 'tbd_prestudy_time',
  TBD_LEVELTEST_IN_APP: 'tbd_leveltest_in_app',
  TUTOR_CONNECT_ALLOWED: 'tutor_connect_allowed_user_ids',
  TBD_260622_REFUND_ESTIMATE_FORM: 'tbd_260622_refund_estimate_form',
  // 추가 무료체험 재신청(Re-Trial): 홈 재신청 카드 노출 + 자격 API 호출 제어
  TBD_260702_RE_TRIAL: 'tbd_260702_re_trial',
  I18N_ENABLED: 'i18n_enabled',
  ONETALK_WIDGET_ENABLED: 'onetalk_widget_enabled',
  JP_TRIAL_ONETALK_HANDOFF: 'jp_trial_onetalk_handoff',
  JP_CARD_REGISTRATION_ENABLED: 'jp_card_registration_enabled',
  LESSON_START_STYLE_ENABLED: 'lesson_start_style_enabled',
  PUSH_NOTIFICATION_OPT_IN: 'push_notification_opt_in',
  SELF_HOLDING_ENABLED: 'self_holding_enabled',
  SELF_WITHDRAWAL_ENABLED: 'self_withdrawal_enabled',
  NOTIFICATION_HISTORY_ENABLED: 'notification_history_enabled',
  // 튜터지정권 미보유 유저에게 스케줄·튜터카드를 블러 처리하는 게이트. OFF면 블러 없이 기존 화면 그대로.
  TUTOR_CONNECT_BLUR: 'tutor-connect-blur',
  SUBSCRIBES_GLOBAL_LEVEL_FILTER: 'subscribes_global_level_filter',
  // QA 등 국내 IP에서도 최초 로그인 국가 선택 화면을 강제로 검증하기 위한 운영 플래그.
  LOGIN_COUNTRY_SELECTION_FORCE: 'login_country_selection_force',
} as const
